import { Component } from '@angular/core';
import { ModalSize, RoutedModalBaseComponent, SlottedModalComponent, SvgIconComponent } from '@woolworthsnz/styleguide';

@Component({
	selector: 'wnz-direct-to-boot-modal',
	templateUrl: './direct-to-boot-modal.component.html',
	styleUrls: ['./direct-to-boot-modal.component.scss'],
	standalone: true,
	imports: [SlottedModalComponent, SvgIconComponent],
})
export class DirectToBootModalComponent extends RoutedModalBaseComponent {
	size = ModalSize.Medium;
}
